import {sourceActionTypes, sourceConstants} from '../_constants';
import {sourceService} from '../_services';
import {alertActions} from './';
import {history, urlHelper} from "../_helpers";
import {portfolioActionTypes} from "../_constants/actions/analytics/portfolioActionTypes";

export const sourceActions = {
    getSources,
    deactivateSource,
    activateSource,
    setCurrentSource,
    orderGist,
    validateLink,
    resetOrder,
    editSource,
    uploadAndValidate,
    resetUploads,
};

/**
 * Redux Action method that fetches for user's sources
 * @returns {Function}
 */
function getSources() {
    return dispatch => {

        // utility constants - contains all module-related dispatches from this function
        const dispatchRequestStarted = () => dispatch({ type: sourceActionTypes.GET_SOURCES_REQUEST });
        const dispatchRequestSuccess = (sources) => dispatch({ type: sourceActionTypes.GET_SOURCES_SUCCESS, sources });
        const dispatchRequestError  = (error) => dispatch({ type: sourceActionTypes.GET_SOURCES_FAILURE, error });

        // dispatch that sources are being fetched
        dispatchRequestStarted();

        // pass the parameters to the service
        sourceService.getSources()
            .then(
                sources => {
                    // dispatch a success if the service returns the sources
                    dispatchRequestSuccess(sources);
                    dispatch(alertActions.success(" Sources successfully fetched. "));
                },
                error => {
                    // dispatch a failure for the fetching sources and alert engine with appropriate message
                    dispatchRequestError(error);
                    dispatch(alertActions.error(error));
                }
            );
    };
}

/**
 * Redux Action method that deactivates a given source
 * @param uuid
 * @returns {Function}
 */
function deactivateSource(uuid) {
    return dispatch => {

        // utility constants
        const dispatchRequestStarted = () => dispatch({ type: sourceActionTypes.DEACTIVATE_SOURCE_REQUEST });
        const dispatchRequestSuccess = (updatedSource) => dispatch({ type: sourceActionTypes.DEACTIVATE_SOURCE_SUCCESS, updatedSource });
        const dispatchRequestError  = () => dispatch({ type: sourceActionTypes.DEACTIVATE_SOURCE_FAILURE });

        // dispatch that sources are being fetched
        dispatchRequestStarted();

        // pass the parameters to the service
        sourceService.setCurrentStatus(uuid, sourceConstants.SOURCE_DEACTIVATE)
            .then(
                (source) => {
                    // dispatch a success if the service deactivates the source
                    dispatchRequestSuccess(source);
                    dispatch(alertActions.success("The source was successfully deactivated."));
                },
                error => {
                    // dispatch a failure for the deactivating source and alert engine with appropriate message
                    dispatchRequestError();
                    dispatch(alertActions.error(error));
                }
            );
    };
}


/**
 * Redux Action method that activates a given source
 * @param uuid
 * @returns {Function}
 */
function activateSource(uuid) {
    return dispatch => {

        // utility constants
        const dispatchRequestStarted = () => dispatch({ type: sourceActionTypes.ACTIVATE_SOURCE_REQUEST });
        const dispatchRequestSuccess = (updatedSource) => dispatch({ type: sourceActionTypes.ACTIVATE_SOURCE_SUCCESS, updatedSource });
        const dispatchRequestError  = () => dispatch({ type: sourceActionTypes.ACTIVATE_SOURCE_FAILURE });

        // dispatch that sources are being fetched
        dispatchRequestStarted();

        // pass the parameters to the service
        sourceService.setCurrentStatus(uuid, sourceConstants.SOURCE_ACTIVATE)
            .then(
                (source) => {
                    // dispatch a success if the service activates the source
                    dispatchRequestSuccess(source);
                    dispatch(alertActions.success("The source was successfully activated."));
                },
                error => {
                    // dispatch a failure for the activating source and alert engine with appropriate message
                    dispatchRequestError();
                    dispatch(alertActions.error(error));
                }
            );
    };
}

/**
 * This sets the current source
 * @param item
 * @returns {Function}
 */
function setCurrentSource(item) {
    return dispatch => {
        const dispatchRequestStarted = (item) => dispatch({ type: sourceActionTypes.SET_CURRENT_SOURCE, item });

        // dispatch that item is being selected as current source
        dispatchRequestStarted(item);
    };
}

/**
 * This function accepts a source with a link and validates it from the server
 * @param source
 * @returns {Function}
 */
function validateLink(source) {
    return dispatch => {
        performValidation(dispatch, source);
    };
}

/**
 * This function accepts a source and validates it
 *
 * @param dispatch dispatch object
 * @param source source to be validated
 */
function performValidation(dispatch, source) {
    // utility constants - contains all module-related dispatches from this function
    const dispatchRequestStarted = () => dispatch({ type: sourceActionTypes.VALIDATE_SOURCE_REQUEST });
    const dispatchRequestSuccess = (source) => dispatch({ type: sourceActionTypes.VALIDATE_SOURCE_SUCCESS, source });
    const dispatchRequestError  = (error) => dispatch({ type: sourceActionTypes.VALIDATE_SOURCE_FAILURE, error });

    dispatchRequestStarted();   // dispatch that validation started

    // pass the parameters to the service
    sourceService.validateSource(source)
        .then(
            source => {
                if( source ){
                    dispatchRequestSuccess(source); // dispatch success
                    dispatch(alertActions.success("The new source was successfully validated."));

                    history.push("/order/confirm")  // push to confirmation page
                }
            },
            error => {
                // dispatch a failure during validation process and alert engine with appropriate message
                dispatchRequestError(error);
                dispatch(alertActions.error(error));
            }
        );
}

/**
 * This function accepts a validated source and orders gist for it.
 * @param source
 * @returns {Function}
 */
function orderGist(source) {
    return dispatch => {

        // utility constants - contains all module-related dispatches from this function
        const dispatchRequestStarted = (source) => dispatch({ type: sourceActionTypes.ORDER_SOURCE_REQUEST, source });
        const dispatchRequestSuccess = (source) => dispatch({ type: sourceActionTypes.ORDER_SOURCE_SUCCESS, source });
        const dispatchRequestError  = (error) => dispatch({ type: sourceActionTypes.ORDER_SOURCE_FAILURE, error });

        // dispatch that sources are being fetched
        dispatchRequestStarted(source);

        // pass the parameters to the service
        sourceService.orderSource(source)
            .then(
                sources => {
                    if( sources ){
                        // dispatch a success if the service returns the sources
                        dispatchRequestSuccess(sources);
                        dispatch(alertActions.success(" Source successfully ordered. "));
                        //redirect to media page
                        history.push("/media");
                    }
                },
                error => {
                    // dispatch a failure for the fetching sources and alert engine with appropriate message
                    dispatchRequestError(error);
                    dispatch(alertActions.error(error));
                }
            );
    };
}

/**
 * This function resets order procedure (before ordering) to start from scratch
 * @returns {Function}
 */
function resetOrder(hosted, link) {
    return dispatch => {
        const dispatchResetStarted = () => dispatch({ type: sourceActionTypes.ORDER_SOURCE_RESET });

        history.goBack();       // go back after cancellation
        dispatchResetStarted(); // reset order params

        if(hosted) {    // iff the order was indicated to be hosted, then delete the abandoned resource
            sourceService.removeUploadResource(link)
                .then(
                    () => dispatch(alertActions.success(" Uploaded Media deleted after order cancellation. "))
                    ,error => dispatch(alertActions.error(error))
                )
        }
    }
}

/**
 * This function edits the property (denoted by param) of the source (with uuid) with value
 * @param uuid the uuid of the source
 * @param param the property of the source to be updated
 * @param value the new value for the property
 * @returns {Function}
 */
function editSource(uuid, param, value){
    return dispatch => {

        // utility constants - contains all module-related dispatches from this function
        const dispatchRequestStarted = () => dispatch({ type: sourceActionTypes.EDIT_SOURCE_REQUEST });
        const dispatchRequestSuccess = (updatedSource) => dispatch({ type: sourceActionTypes.EDIT_SOURCE_SUCCESS, updatedSource });
        const dispatchRequestError  = () => dispatch({ type: sourceActionTypes.EDIT_SOURCE_FAILURE });
        const dispatchSourceRenameSuccess = () => dispatch({type: portfolioActionTypes.SOURCE_RENAME_TITLE_SUCCESS});

        // dispatch that sources are being fetched
        dispatchRequestStarted();

        // pass the parameters to the service
        sourceService.editSource(uuid, param, value)
            .then(
                source => {
                    if( source ){
                        // dispatch a success if the service returns the sources
                        dispatchRequestSuccess( source );
                        dispatch(alertActions.success(" Source successfully edited. "));

                        // if source title was successfully edited
                        if(param === sourceConstants.SOURCE_TITLE) {
                            dispatchSourceRenameSuccess();
                        }
                    }
                },
                error => {
                    // dispatch a failure for the fetching sources and alert engine with appropriate message
                    dispatchRequestError();
                    dispatch(alertActions.error(error));
                }
            );
    };
}

/**
 * Accepts data, generates upload-url and uploads the data
 *
 * @param data the content to be uploaded
 * @returns {function(...[*]=)}
 */
function uploadAndValidate(data){
    return dispatch => {
        // fetching signed-url for upload
        const getSignedUrl = (params) => {
            // get signed-upload-url dispatches
            const dispatchUrlRequestStarted = () => dispatch({ type: sourceActionTypes.GET_UPLOAD_PACKET_REQUEST });
            const dispatchUrlRequestSuccess = (packet) => dispatch({ type: sourceActionTypes.GET_UPLOAD_PACKET_SUCCESS, packet });
            const dispatchUrlRequestError  = () => dispatch({ type: sourceActionTypes.GET_UPLOAD_PACKET_FAILURE });

            // dispatch that the upload-url is being requested
            dispatchUrlRequestStarted();

            // call the service for upload-url
            return sourceService.getSignedUploadUrl(params)
                .then( response => {
                        // dispatch that the service has returned that upload-url
                        dispatchUrlRequestSuccess(response);

                        const {signedUrl, uploadHeaders} = response;
                        return {    // return the upload packet
                            "url" : signedUrl,
                            "headers" : uploadHeaders,
                            "content" : data,
                        };
                    }, error => {
                        dispatchUrlRequestError();
                        throw error;
                    }
                );
        };

        // performing upload using upload-packet
        const performUpload = (uploadPacket) => {
            // upload source dispatches
            const dispatchUploadRequestStarted = () => dispatch({ type: sourceActionTypes.UPLOAD_SOURCE_REQUEST });
            const dispatchUploadRequestSuccess = (url) => dispatch({ type: sourceActionTypes.UPLOAD_SOURCE_SUCCESS, url });
            const dispatchUploadRequestError  = (error) => dispatch({ type: sourceActionTypes.UPLOAD_SOURCE_FAILURE, error });

            // dispatch that the upload process has begun
            dispatchUploadRequestStarted();

            // call the service to upload
            return sourceService.upload(uploadPacket)
                .then( () => {
                        const uploadedUrl = urlHelper.getUrlWithoutParams(uploadPacket.url);
                        dispatchUploadRequestSuccess(uploadedUrl);  // dispatch upload success

                        return {
                            "title": data.name,
                            "probeUri": uploadedUrl,
                            "hosted": true,
                        }
                    }, error => {
                        dispatchUploadRequestError(error);
                        throw error;
                    }
                );
        };

        const uploadMetaData = {
            "contentType": data.type,                               // content-type
            "extension": (/(?:\.([^.]+))?$/).exec(data.name)[1],    // extension
        }

        // invoke : get signed-url and then upload
        getSignedUrl(uploadMetaData)
            .then(performUpload)
            .then((source) => performValidation(dispatch, source))
            .catch( error => dispatch(alertActions.error(error)) );
    };
}

/**
 * Resets the uploads information
 *
 * @returns {function(...[*]=)}
 */
function resetUploads() {
    return dispatch => {
        const dispatchResetStarted = () => dispatch({ type: sourceActionTypes.UPLOAD_SOURCE_RESET });
        dispatchResetStarted(); // reset uploads
    }
}